module.exports = __webpack_public_path__ + "static/img/bg@2x.393140d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg@2x.jpg
// module id = VTuj
// module chunks = 14